import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";

import SelectMenu from "../../../controls/SelectMenu";
import { classNames, userTypeOptions } from "../../../../shared/utility";

import Button from "../../../controls/Button";

const initialFValues = {
  name: "",
  username: "",
  user_type: 0,
  email: "",
};

export default function UserDetailsForm(props) {
  const { actionCall, user, isEdit, resetPassword, setOpen, title } = props;

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (fieldValues.name.value === -1) {
        temp.name = "This field is required.";
      }
    }

    if ("username" in fieldValues) {
      temp.username = null;
      if (fieldValues.username.value === -1) {
        temp.username = "This field is required.";
      }
    }

    if ("password" in fieldValues && !isEdit) {
      temp.password = null;
      if (fieldValues.password === "") {
        temp.password = "This field is required.";
      }
    }

    if ("password_confirmation" in fieldValues && !isEdit) {
      temp.password_confirmation = null;
      if (fieldValues.password_confirmation === "") {
        temp.password_confirmation = "This field is required.";
      }

      if (fieldValues.password_confirmation !== values.password) {
        temp.password_confirmation = "The passwords do not match.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall({ ...values, user_type: values.user_type.value });
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues(user);
    }
  }, [user, setValues]);

  return (
    <form className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {title}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-4">
          <Input
            label="Name"
            name="name"
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <Input
            label="User name"
            name="username"
            onChange={handleInputChange}
            value={values.username}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <Input
            label="Email"
            name="email"
            onChange={handleInputChange}
            value={values.email}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />

          <SelectMenu
            handleInputChange={handleInputChange}
            name="user_type"
            options={userTypeOptions}
            value={values.user_type}
            title={"User Type"}
            error={errors.user_type}
            showLabel={true}
          />

          <>
            <Input
              label="Set Password"
              name="password"
              onChange={handleInputChange}
              value={values.password}
              labelOn={true}
              type="password"
              autocomplete="off"
              error={errors.password}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Input
              label="Confirm Password"
              name="password_confirmation"
              onChange={handleInputChange}
              value={values.password_confirmation}
              labelOn={true}
              type="password"
              autocomplete="off"
              error={errors.password_confirmation}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            />

            <Button
              className={classNames(isEdit ? undefined : "hidden")}
              onClick={() => {
                if (values.password === values.password_confirmation) {
                  resetPassword({
                    id: values.id,
                    password: values.password,
                    password_confirmation: values.password_confirmation,
                  });
                } else {
                  setErrors({
                    ...errors,
                    password: "Passwords do not match",
                    password_confirmation: "Passwords do not match",
                  });
                }
              }}
            >
              Reset
            </Button>
          </>
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <Button variant="secondary" onClick={() => setOpen({ childComponent: null, open: false })}>Cancel</Button>
        <Button type="submit" className="ml-4" onClick={handleSubmit}>{isEdit ? "Save" : "Create"}</Button>
      </div>
    </form>
  );
}
